import {isAndroid, isIOS} from './useragent';
import callIOS from './callIos';
import callAndroid from './callAndroid';

// 基础配置
let appConfig = {
    PROTOCOL: '', // 协议
    APPLINK: '', // app link 应用宝链接
    UNIVERSALLINK: 'https://universelink.yftepay.com/', // ios link链接
    USEAPPLINK: false, // 是否使用 微信的app link
    USEUNIVERSALLINK: true, // 是否使用iOS 的link
    USEANDROIDSCHEMA: true, // 是否使用android schema
    USEIOSSCHEMA: true, // 是否使用iOS schema
};

/**
 * 调起入口
 *
 * @param {Object} options
 * action 必填
 */
function callClient(options) {
    if (!options) {
        return;
    }
    if (typeof options.action !== 'string') {
        return;
    }
    // 根据 action 去判定调起的行为（分享，下载，剪切板等），其余参数放入params
    let obj = Object.assign({
        action: '',
        params: '',
        errorCallback: function () {
            window.globalVue.$router.push('wapDownload');
        }
    }, options);
    if (isAndroid()) {
        callAndroid(obj);
    } else {
        callIOS(obj);
    }
}

callClient.isAndroid = isAndroid();
callClient.isIOS = isIOS();

// 需要先配置基本信息 PROTOCOL 必填
callClient.initAppConfig = (config) => {
    if (!config) {
        return;
    }
    if (typeof config.PROTOCOL !== 'string') {
        return;
    }
    appConfig = Object.assign(appConfig, config);
    callAndroid.initConfig(appConfig);
    callIOS.initConfig(appConfig);
};

export default callClient;